import React from 'react';
import { Link } from 'react-router-dom';
import './Card.scss';

const Card=(props)=>{
    return(
        <Link to={props.to}>
        <div className="customer-card" data-aos="fade-up"
        data-aos-delay={props.delay}>
            <div className="image-part" style={{ backgroundImage: `url(${props.Image})` }}></div>
            <div class="custom-shape-divider-bottom-1626632954">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
    </svg>

            </div>
            <img src={props.logo} />
            {props.desc ? <p>{props.desc}</p> : null}
            <p className="read" style={{ color: `${props.color}` }}>Read More</p>
        </div>
        </Link>
    )
};
export default Card ;